<template>
  <head>
    <title>{{ $t("title") }}</title>

    <meta
      name="description"
      :content="
        $i18n.locale === 'ar'
          ? data.about_us_ar + ' Nexus Leap, نكسس ليب'
          : data.about_us_en + ' Nexus Leap, نكسس ليب'
      "
    />
  </head>
  <NavbarComponent />
  <div class="home" v-if="Object.keys(data).length > 0">
    <!-- ======= Hero Section ======= -->
    <section
      id="hero"
      class="hero d-flex align-items-center"
      :style="{
        backgroundPosition: $i18n.locale === 'ar' ? 'left' : 'right',
        background: 'url(' + $store.state.server + data.welcome_img + ')',
      }"
    >
      <div class="container">
        <div class="row d-flex justify-content-center align-items-end w-100">
          <div class="col-xl-4 text-center">
            <!-- <h2 data-aos="fade-up">{{ $t("title") }}</h2> -->
            <img
              data-aos="fade-up"
              src="assets/img/LogoWhite2.png"
              alt="LogoWhite"
              height="200px"
              :style="{
                padding: $i18n.locale === 'ar' ? '0 15px 0 0' : '20px 0 0 30px',
              }"
            />
            <blockquote data-aos="fade-up" data-aos-delay="100">
              <!-- :style="{ padding: $i18n.locale === 'ar' ? '0 20px 0 0' : '0 0 0
              20px', borderLeft: $i18n.locale === 'ar' ? '' : '2px solid
              var(--color-primary)', borderRight: $i18n.locale === 'ar' ? '2px
              solid var(--color-primary)' : '', }" -->
              {{
                $i18n.locale == "ar"
                  ? data.welcome_message_ar
                  : data.welcome_message_en
              }}
            </blockquote>
            <div
              class="d-flex justify-content-center align-items-center"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <a
                :href="'https://wa.me/' + $store.state.phone"
                class="btn-get-started"
                target="_blank"
                >{{ $t("ASK") }}</a
              >
              <!-- <a
                href="https://www.youtube.com/watch?v=LXb3EKWsInQ"
                class="glightbox btn-watch-video d-flex align-items-center"
                ><i class="bi bi-play-circle"></i><span>Watch Video</span></a
              > -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Hero Section -->

    <!-- ======= main ======= -->
    <main id="main">
      <div class="artboard"></div>

      <!-- ======= About Section ======= -->
      <section id="about" class="about">
        <div class="container" data-aos="fade-up">
          <div class="row gy-4" data-aos="fade-up">
            <div class="col-lg-4 d-flex align-items-center">
              <img
                :src="
                  $i18n.locale === 'ar'
                    ? $store.state.server + data.about_us_img_ar
                    : $store.state.server + data.about_us_img_en
                "
                class="img-fluid"
                alt=""
              />
            </div>
            <div class="col-lg-8 d-flex align-items-center">
              <div class="content ps-lg-5">
                <!-- <h3>{{ $t("about") }}</h3> -->
                <p>
                  {{
                    $i18n.locale === "ar" ? data.about_us_ar : data.about_us_en
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- End About Section -->

      <!-- ======= Vision Section ======= -->
      <section id="vision" class="about">
        <div class="container" data-aos="fade-up">
          <div class="row gy-4" data-aos="fade-up">
            <div
              class="col-lg-4 d-flex align-items-center"
              v-if="ScreenWidth <= 995"
            >
              <img
                :src="
                  $i18n.locale === 'ar'
                    ? $store.state.server + data.our_vision_img_ar
                    : $store.state.server + data.our_vision_img_en
                "
                class="img-fluid"
                alt=""
              />
            </div>
            <div class="col-lg-8 d-flex align-items-center">
              <div class="content pe-lg-5">
                <!-- <h3>{{ $t("vision.title") }}</h3> -->
                <p>
                  {{
                    $i18n.locale === "ar"
                      ? data.our_vision_message_ar
                      : data.our_vision_message_en
                  }}
                </p>
              </div>
            </div>
            <div
              class="col-lg-4 d-flex align-items-center"
              v-if="ScreenWidth > 995"
            >
              <img
                :src="
                  $i18n.locale === 'ar'
                    ? $store.state.server + data.our_vision_img_ar
                    : $store.state.server + data.our_vision_img_en
                "
                class="img-fluid"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
      <!-- End Vision Section -->

      <!-- ======= Why Choose Us Section ======= -->
      <section id="why-us" class="why-us" v-if="services && services.length">
        <div class="container" data-aos="fade-up">
          <!-- <div class="section-header">
            <h2>{{ $t("why") }}</h2>
          </div> -->

          <div class="row g-0" data-aos="fade-up" data-aos-delay="200">
            <div
              class="col-xl-4 d-flex align-items-center"
              :class="$i18n.locale === 'ar' ? 'ps-lg-5' : 'pe-lg-5'"
            >
              <img
                :src="
                  $i18n.locale === 'ar'
                    ? $store.state.server + data.why_nexus_img_ar
                    : $store.state.server + data.why_nexus_img_en
                "
                class="img-fluid"
                alt=""
              />
            </div>
            <div class="col-xl-8 slides position-relative">
              <div class="slides-1 swiper">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(item, index) in services"
                    :key="index"
                  >
                    <div class="item">
                      <h3 class="mb-3">
                        {{ $i18n.locale == "ar" ? item.name_ar : item.name_en }}
                      </h3>
                      <h4 class="mb-3">
                        {{
                          $i18n.locale == "ar" ? item.title_ar : item.title_en
                        }}
                      </h4>
                      <p>
                        {{
                          $i18n.locale == "ar"
                            ? item.description_ar
                            : item.description_en
                        }}
                      </p>
                    </div>
                  </div>
                  <!-- End slide item -->
                </div>
                <div class="swiper-pagination"></div>
              </div>
              <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
            </div>
          </div>
        </div>
      </section>
      <!-- End Why Choose Us Section -->

      <!-- ======= Our International Representation Section ======= -->
      <section
        id="representation"
        class="about"
        v-if="partners && partners.length"
      >
        <div class="container" data-aos="fade-up">
          <div class="row gy-4" data-aos="fade-up">
            <div
              class="col-lg-4 d-flex align-items-center"
              v-if="ScreenWidth <= 995"
            >
              <img
                :src="
                  $i18n.locale === 'ar'
                    ? $store.state.server + data.our_partners_img_ar
                    : $store.state.server + data.our_partners_img_en
                "
                class="img-fluid"
                alt=""
              />
            </div>
            <div class="col-lg-8 d-flex align-items-center">
              <div class="content pe-lg-5">
                <!-- <h3>{{ $t("representation.title") }}</h3> -->
                <h4 class="my-4" style="color: var(--color-primary)">
                  {{
                    $i18n.locale === "ar"
                      ? data.our_partners_ar
                      : data.our_partners_en
                  }}
                </h4>
                <ul>
                  <li
                    style="font-size: 18px"
                    v-for="(item, index) in partners"
                    :key="index"
                  >
                    <i class="bi bi-check-circle-fill"></i>
                    {{ $i18n.locale == "ar" ? item.name_ar : item.name_en }}:
                    {{
                      $i18n.locale == "ar"
                        ? item.description_ar
                        : item.description_en
                    }}
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="col-lg-4 d-flex align-items-center"
              v-if="ScreenWidth > 995"
            >
              <img
                :src="
                  $i18n.locale === 'ar'
                    ? $store.state.server + data.our_partners_img_ar
                    : $store.state.server + data.our_partners_img_en
                "
                class="img-fluid"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
      <!-- End Our International Representation Section -->

      <!-- ======= Our Services Section ======= -->
      <section id="services" class="services">
        <div class="container">
          <div class="section-header">
            <h2>{{ $t("servicestitle") }}</h2>
          </div>

          <div class="row">
            <div
              class="col-lg-4 col-md-6 d-flex align-items-stretch my-3"
              data-aos="fade-up"
              v-for="(item, index) in products"
              :key="index"
            >
              <a
                :href="
                  item.link && item.link !== 'null'
                    ? item.link
                    : '/service?id=' + item.id
                "
                :target="item.link && item.link !== 'null' ? '_blank' : ''"
                style="color: black; text-decoration: none"
              >
                <div class="icon-box">
                  <div class="icon" v-html="item.icon"></div>
                  <h4>
                    <a
                      :href="
                        item.link && item.link !== 'null'
                          ? item.link
                          : '/service?id=' + item.id
                      "
                      :target="
                        item.link && item.link !== 'null' ? '_blank' : ''
                      "
                      >{{
                        $i18n.locale == "ar" ? item.name_ar : item.name_en
                      }}</a
                    >
                  </h4>
                  <p>
                    {{ $i18n.locale == "ar" ? item.title_ar : item.title_en }}
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <!-- End Our Services Section -->

      <!-- NumberSection -->
      <NumberSection
        v-if="numbers && numbers.length"
        :numbers="numbers"
      ></NumberSection>
      <!-- End -->

      <!-- ======= Team Section ======= -->
      <section id="team" class="team" v-if="team && team.length">
        <div class="container" data-aos="fade-up">
          <div class="section-header">
            <h2>{{ $t("Team") }}</h2>
          </div>

          <div class="row gy-4">
            <div
              class="col-lg-3 col-md-6"
              data-aos="fade-up"
              data-aos-delay="100"
              v-for="(item, index) in team"
              :key="index"
            >
              <div class="team-member">
                <div class="member-img">
                  <img
                    :src="$store.state.server + item.img"
                    class="img-fluid"
                    alt=""
                  />
                  <div class="social">
                    <span
                      v-for="(item2, index2) in item.social_media"
                      :key="index2"
                    >
                      <a
                        :href="item2"
                        v-if="
                          item2 != null &&
                          item2 != '' &&
                          item2 != 'NULL' &&
                          index2 != 'created_at' &&
                          index2 != 'id' &&
                          index2 != 'updated_at' &&
                          index2 != 'linkdin'
                        "
                        ><i :class="'bi bi-' + index2"></i
                      ></a>
                    </span>
                  </div>
                </div>
                <div class="member-info">
                  <h4>
                    {{ $i18n.locale === "ar" ? item.name_ar : item.name_en }}
                  </h4>
                  <span>{{
                    $i18n.locale === "ar" ? item.position_ar : item.position_en
                  }}</span>
                  <span>{{
                    $i18n.locale === "ar" ? item.quote_ar : item.qoute_en
                  }}</span>
                </div>
              </div>
            </div>
            <!-- End Team Member -->
          </div>
        </div>
      </section>
      <!-- End Team Section -->

      <!-- ======= Testimonials Section ======= -->
      <section id="news" class="testimonials" v-if="news && news.length">
        <div class="container blog" data-aos="fade-up">
          <div class="section-header">
            <h2>{{ $t("blogs") }}</h2>
          </div>

          <div class="slides-3 swiper" data-aos="fade-up" data-aos-delay="100">
            <div class="swiper-wrapper posts-list">
              <div
                class="swiper-slide"
                v-for="(item, index) in news"
                :key="index"
              >
                <article class="d-flex flex-column blog">
                  <div class="post-img">
                    <img
                      :src="
                        $store.state.server +
                        ($i18n.locale == 'ar' ? item.img : item.img_en)
                      "
                      alt=""
                      class="img-fluid"
                    />
                  </div>

                  <h2 class="title-blog mb-4">
                    <a href="/" style="cursor: none; pointer-events: none">{{
                      $i18n.locale == "ar" ? item.name_ar : item.name_en
                    }}</a>
                  </h2>

                  <div class="read-more mt-auto align-self-end">
                    <a :href="'/news-details?id=' + item.id"
                      >{{
                        $i18n.locale == "ar" ? "قراءة المزيد" : "Read more"
                      }}
                      <i
                        :class="
                          $i18n.locale == 'ar'
                            ? 'bi bi-arrow-left'
                            : 'bi bi-arrow-right'
                        "
                      ></i
                    ></a>
                  </div>
                </article>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </section>
      <!-- End Testimonials Section -->

      <!-- ======= Testimonials Section 222 222 ======= -->
      <section
        id="stories"
        class="testimonials"
        v-if="stories && stories.length"
      >
        <div class="container blog" data-aos="fade-up">
          <div class="section-header">
            <h2>{{ $t("stories") }}</h2>
          </div>

          <div class="slides-32 swiper" data-aos="fade-up" data-aos-delay="100">
            <div class="swiper-wrapper posts-list">
              <div
                class="swiper-slide"
                v-for="(item, index) in stories"
                :key="index"
              >
                <article class="d-flex flex-column blog">
                  <div class="post-img">
                    <img
                      :src="
                        $store.state.server +
                        ($i18n.locale == 'ar' ? item.img : item.img_en)
                      "
                      alt=""
                      class="img-fluid"
                    />
                  </div>

                  <h2 class="title-blog mb-4">
                    <a href="/" style="cursor: none; pointer-events: none">{{
                      $i18n.locale == "ar" ? item.name_ar : item.name_en
                    }}</a>
                  </h2>

                  <div class="read-more mt-auto align-self-end">
                    <a :href="'/story-details?id=' + item.id"
                      >{{
                        $i18n.locale == "ar" ? "قراءة المزيد" : "Read more"
                      }}
                      <i
                        :class="
                          $i18n.locale == 'ar'
                            ? 'bi bi-arrow-left'
                            : 'bi bi-arrow-right'
                        "
                      ></i
                    ></a>
                  </div>
                </article>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </section>
      <!-- End Testimonials Section 222 222 -->

      <!-- ======= Testimonials Section 333 ======= -->
      <section
        id="our-partners"
        class="testimonials"
        v-if="partners_stratigic && partners_stratigic.length"
      >
        <div class="container blog" data-aos="fade-up">
          <div class="section-header">
            <h2>{{ $t("OurPartneres.title") }}</h2>
          </div>

          <PartnersSlider :partners_stratigic="partners_stratigic" />
        </div>
      </section>
      <!-- End Testimonials Section 333 -->

      <!-- ======= Contact Us Section ======= -->
      <section id="contact" class="call-to-action">
        <div class="container" data-aos="fade-up">
          <div class="row justify-content-center">
            <div class="col-lg-6 text-center">
              <h3>{{ $t("ContactUsTitle") }}</h3>
              <p style="text-align: center !important">
                {{ $t("ContactUsText") }}
              </p>
              <a class="cta-btn" href="mailto:info@nexusleap.com.sa">
                {{ $t("ContactUsButton") }}
              </a>
            </div>
          </div>
        </div>
      </section>
      <!-- End Contact Us Section -->

      <!-- MAP SECTION -->
      <section
        id="map"
        style="margin: 0; padding: 0"
        v-if="
          data.map_link != '' &&
          data.map_link != null &&
          data.map_link != 'NULL'
        "
      >
        <iframe
          :src="data.map_link"
          width="100%"
          height="450"
          style="border: 0; margin: 0"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </section>
      <!-- ENd MAP SECTIOn -->
      <div class="artboard"></div>
    </main>
    <!-- End #main -->
  </div>
</template>

<script>
import NavbarComponent from "@/components/NavbarComponent.vue";
import NumberSection from "@/components/NumberSection.vue";
import PartnersSlider from "@/components/PartnersSlider.vue";
import store from "@/store";
import axios from "axios";
export default {
  name: "HomeView",
  data() {
    return {
      ScreenWidth: screen.width,
      data: {},
      products: [],
      services: [],
      team: [],
      partners: [],
      news: [],
      stories: [],
      partners_stratigic: [],
      numbers: [],
    };
  },
  components: {
    NavbarComponent,
    NumberSection,
    PartnersSlider,
  },
  methods: {
    getData() {
      store.state.loading_state = 1;
      axios
        .get(store.state.server + "api/get_website_id/1")
        .then((response) => {
          this.data = response.data.data;
          this.products = this.data.products;
          this.services = this.data.services;
          this.team = this.data.team;
          this.news = this.data.news;
          this.stories = this.data.stories;
          this.partners_stratigic = this.data.partners;
          this.numbers = this.data.numbers;
          window.localStorage.setItem(
            "stories",
            Object.keys(this.stories).length
          );
          store.state.stories = Object.keys(this.stories).length;
          this.partners = this.data.clients;
          store.state.phone = this.data.phone;
          store.state.instagram = this.data.social_media.instagram;
          store.state.linkdin = this.data.social_media.linkdin;
          store.state.twitter = this.data.social_media.twitter;
          store.state.facebook = this.data.social_media.facebook;
          store.state.loaction_name_ar = this.data.loaction_name_ar;
          store.state.loaction_name_en = this.data.location_name_en;
          store.state.email = this.data.email;
          store.state.welcome_message_ar = this.data.welcome_message_ar;
          store.state.welcome_message_en = this.data.welcome_message_en;
          store.state.products = this.data.products;
          window.localStorage.setItem(
            "products",
            JSON.stringify(this.data.products)
          );
          window.localStorage.setItem(
            "instagram",
            this.data.social_media.instagram
          );
          window.localStorage.setItem(
            "linkdin",
            this.data.social_media.linkdin
          );
          window.localStorage.setItem(
            "twitter",
            this.data.social_media.twitter
          );
          window.localStorage.setItem(
            "facebook",
            this.data.social_media.facebook
          );
          window.localStorage.setItem("phone", this.data.phone);
          window.localStorage.setItem(
            "loaction_name_ar",
            this.data.loaction_name_ar
          );
          window.localStorage.setItem(
            "location_name_en",
            this.data.location_name_en
          );
          window.localStorage.setItem("email", this.data.email);
          window.localStorage.setItem(
            "welcome_message_ar",
            this.data.welcome_message_ar
          );
          window.localStorage.setItem(
            "welcome_message_en",
            this.data.welcome_message_en
          );
          store.state.loading_state = 0;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getData();
    sessionStorage.clear();
  },
};
</script>

<style scoped>
.title-blog {
  font-size: 20px;
  font-weight: 600;
  padding: 0;
  margin: 20px 0 0 0;
}

.blog a {
  color: var(--color-secondary);
  transition: 0.3s;
}

.blog a:hover {
  color: var(--color-primary);
}

.my_card {
  margin: 50px 0 0 0;
  border-radius: 10px !important;
  border: none !important;
}
</style>
